module.exports = __webpack_public_path__ + "static/img/program.57c4f1e3.png";